import { nanoid } from 'nanoid';
import { when, reaction } from 'mobx';
import { Answer } from '../../../question/answer/Answer';
export class FunnelPreload {
    parent;
    constructor(parent) {
        this.parent = parent;
        this.preloader = reaction(() => this.answerAndAssetsPreload, (answer, previousValue) => {
            if (answer) {
                console.log('preload Question', answer.question_id);
            }
        }, {
            scheduler: (typeof window !== 'undefined' && window.requestIdleCallback) || window.requestAnimationFrame,
        });
    }
    preloader;
    get funnel() {
        return this.parent;
    }
    get app() {
        return this.funnel.app;
    }
    createAnswerById(question_id) {
        const answer = Answer.fromSerialized({
            question_id,
            parent: this.app,
            id: `${nanoid(12)}`,
            type: 'answer',
            timestamp: null,
            user_id: this.app.user.id,
            topic_id: this.app.solidTopic.id,
        });
        return answer;
    }
    async preloadQuestionId(id) {
        // used by app webview
        console.log('Preload question', id);
        const preloadAnswer = this.app.tray.trayTransform.questionIdToAnswer(id);
        await when(() => !!preloadAnswer.answerPrepare.isPrepared);
    }
    get answerAndAssetsPreload() {
        if (!this.app.appBoot.isInteractiveStable)
            return undefined;
        const preloadAnswer = this.app.funnel.funnelLine.nextAnswer;
        if (!preloadAnswer)
            return undefined;
        const preloadAssets = preloadAnswer.answerPrepare.isPrepared;
        return preloadAnswer;
    }
}
